import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import * as fromSearchBox from '@offconon/shared/ui/search-box';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(fromSearchBox.SEARCHBOX_FEATURE_KEY, fromSearchBox.searchBoxReducer),
  ],
})
export class SearchBoxFeatureModule {}
